import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const UpstreamDatasourcesFilteredByFieldQueryGql: DocumentNode = gql`
query UpstreamDatasourcesFilteredByFieldQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowDataFragment
        }
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
